// Numeric renderer — plan §6.3 + Ek A. <input type="number"> + birim göstergesi sağda.

import type { QuestionSnapshot } from "@mahir/shared";

interface Props {
  question: QuestionSnapshot;
  value: number | null;
  onChange: (v: number | null) => void;
}

export function NumericRenderer({ question, value, onChange }: Props): JSX.Element {
  const opts = question.options as { unit?: string; min?: number; max?: number } | null;
  const unit = opts?.unit && opts.unit.length > 0 ? opts.unit : null;

  return (
    <div className="flex items-stretch gap-0">
      <input
        type="number"
        value={value ?? ""}
        min={opts?.min}
        max={opts?.max}
        onChange={(e) => {
          const raw = e.target.value;
          if (raw === "") {
            onChange(null);
            return;
          }
          const n = Number(raw);
          if (Number.isFinite(n)) onChange(n);
        }}
        className="flex-1 rounded-l-lg px-3 py-2 text-sm"
        style={{
          background: "var(--color-surface)",
          border: "1px solid var(--color-border)",
          borderRight: unit ? "none" : "1px solid var(--color-border)",
          borderRadius: unit ? "8px 0 0 8px" : undefined,
          color: "var(--color-text)",
          fontFamily: "var(--font-mono)",
        }}
      />
      {unit && (
        <div
          className="px-3 py-2 text-sm rounded-r-lg"
          style={{
            background: "var(--color-bg)",
            border: "1px solid var(--color-border)",
            color: "var(--color-text-3)",
            fontFamily: "var(--font-mono)",
            display: "flex",
            alignItems: "center",
          }}
        >
          {unit}
        </div>
      )}
    </div>
  );
}
